import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import React from "react";
import { useHistory } from "react-router-dom";

// Same internal SPA route already used elsewhere for this handbook (App.tsx's own
// /global_ms_sales/handbook_pdf_page route, IgniteNissanHandbookPdf, also linked from the G-M&S
// menu itself - menuItems.ts). history.push (not a plain <a href>) since this is an internal
// route, matching GoogleConnectTileContent.tsx's own link.
export const HandbookTileContent = () => {
  const history = useHistory();

  return (
    <>
      <p className="faq_tile_text">
        The G-M&amp;S Re:Ignite Control Handbook covers Global Marketing &amp; Sales&apos; own reporting structure, KPI definitions and how
        to read each tier&apos;s dashboards.
      </p>
      <button
        className="faq_button_primary"
        onClick={() => history.push({ pathname: "/global_ms_sales/handbook_pdf_page", search: "" })}
        data-test-id="handbook-pdf-link"
      >
        <MenuBookOutlinedIcon fontSize="small" />
        Open Handbook
      </button>
    </>
  );
};
